import { render, staticRenderFns } from "./final-questions.vue?vue&type=template&id=c631ca02&scoped=true&"
import script from "./final-questions.vue?vue&type=script&lang=js&"
export * from "./final-questions.vue?vue&type=script&lang=js&"
import style0 from "./final-questions.vue?vue&type=style&index=0&id=c631ca02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c631ca02",
  null
  
)

export default component.exports